import React, { useState, useEffect, useCallback } from 'react';
import debounce from "lodash.debounce";
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { InputFieldsWrapper } from '.././PTPlusStyled'
import RightArrow from "web/assets/images/right-arrow-dark-blue.webp";
import TextInput from 'web/components/form-elements/TextInput';
import PhoneNumber from 'web/components/form-elements/PhoneNumber';
import NumberInput from 'web/components/form-elements/NumberInput';
import CheckboxInput from 'web/components/form-elements/CheckboxInput';
import states from 'states-us';
import { adminRegisterUserApi, checkIsValidEmail, checkIsZipCode } from 'redux/actions/adminPtPlus/index';
import { Tooltip } from 'reactstrap';
import { storeAdminDetails, logoutAdmin} from 'redux/actions/admin';
import information from "web/assets/images/informationIcon.png";

import AlertModal from 'web/components/AlertModal';

function BillTo(pageProps) {
    const dispatch = useDispatch();
    let history = useHistory()
    const [alertModal, setAlertModal] = useState(false);
    const [alertModalContent, setAlertModalContent] = useState('');

    const [saveDisableState, setSaveDisableState] = useState(true)
    const [isValidEmail, setIsValidEmail] = useState(true)
    const [isValidZip, setIsValidZip] = useState(true)

    const territoryStates = states.filter((x) => x.contiguous);
    let stateArr = []
    for (let i = 0; i < territoryStates.length; i++) {
        if (territoryStates[i].name !== 'District Of Columbia') {
            let obj = {
                value: territoryStates[i].name,
                label: `${territoryStates[i].abbreviation}-${territoryStates[i].name}`,
                isoCode: territoryStates[i].abbreviation
            }
            stateArr.push(obj)
        }
    }

    useEffect(() => {
        let fieldValues = pageProps.formikProps.values
        if (fieldValues.billToCheckBox) {
            // if (fieldValues.taxId.trim().length === 9 && parseInt(fieldValues.taxId?.trim()) > 0) setSaveDisableState(false)
            // else setSaveDisableState(true)
            setSaveDisableState(false)
        } else {
            if (isValidZip && fieldValues.billToUserName.trim() !== '' && fieldValues.billToPhoneNumber.trim() !== '' && fieldValues.billToBusinessName.trim() !== '' && fieldValues.billToEmail.trim() && !pageProps.formikProps.errors.otherToEmail  &&
                fieldValues.billToAddress.trim() !== '' && fieldValues.billToCity.trim() !== '' && fieldValues.billToState.trim() !== '' && fieldValues.billToZip.trim() !== '' && parseInt(fieldValues.billToZip) > 0) {
                setSaveDisableState(false)
            } else setSaveDisableState(true)
        }
    }, [pageProps.formikProps, isValidZip])

    const [tooltip, setTooltip] = useState(false);
    const [tooltipSection, setTooltipSection] = useState('');
    const iIcon = (infoSection, infoTxt) => {
        return <>
            <img
                id={infoSection}
                src={information}
                style={{ position: "relative", top: "2px", left: '-5px' }}
            />
            <Tooltip
                placement="right"
                isOpen={tooltip && tooltipSection === infoSection}
                target={infoSection}
                toggle={() => {
                    setTooltip(!tooltip)
                    setTooltipSection(tooltipSection === '' ? infoSection : '')
                }
                }
            >
                {infoTxt}
            </Tooltip>
        </>
    }

    const adminRegisterUserFunc = async () => {
        let fieldValues = pageProps.formikProps.values
        let response = '';
        let data = {
            id: pageProps.tempRegId,
            emailAddress: fieldValues.email?.trim(),
            contactNumber: fieldValues.phoneNumber?.trim(),
            customerName: fieldValues.userName?.trim(),
            locationName: fieldValues.businessName?.trim(),
            notes: fieldValues.notes?.trim(),
            billToEmailAddress: fieldValues.billToCheckBox ? fieldValues.email?.trim() : fieldValues.billToEmail?.trim(),
            otherContactEmail: fieldValues.otherToEmail ? fieldValues.otherToEmail.trim() : null,
            locationAddress: {
                name: fieldValues.businessName?.trim(),
                contactNumber: fieldValues.phoneNumber?.trim(),
                locationName: fieldValues.businessName?.trim(),
                street: fieldValues.address?.trim(),
                city: fieldValues.city?.trim(),
                state: fieldValues.state?.trim(),
                zipCode: fieldValues.zip?.trim(),
            },
            billingAddress: {
                name: fieldValues.billToCheckBox ? fieldValues.userName?.trim() : fieldValues.billToUserName?.trim(),
                contactNumber: fieldValues.billToCheckBox ? fieldValues.phoneNumber?.trim() : fieldValues.billToPhoneNumber?.trim(),
                locationName: fieldValues.billToCheckBox ? fieldValues.businessName?.trim() : fieldValues.billToBusinessName?.trim(),
                street: fieldValues.billToCheckBox ? fieldValues.address?.trim() : fieldValues.billToAddress?.trim(),
                city: fieldValues.billToCheckBox ? fieldValues.city?.trim() : fieldValues.billToCity?.trim(),
                state: fieldValues.billToCheckBox ? fieldValues.state?.trim() : fieldValues.billToState?.trim(),
                zipCode: fieldValues.billToCheckBox ? fieldValues.zip?.trim() : fieldValues.billToZip?.trim()
            },
            businessInfo: {
                taxId: fieldValues.taxId?.trim(),
                businessUrl: fieldValues.businessURL?.trim(),
                businessDescription: fieldValues.businessDescription?.trim()
            },
            registrationStatus: "DRAFT"
        }
        const token = localStorage.getItem('token')
        response = await dispatch(adminRegisterUserApi(data, token))
        if (response.success) {
            setAlertModalContent('Details saved successfully.')
            setAlertModal(!alertModal)
            setTimeout(() => {
                pageProps.nextStepCallBack('forward', 'step2')
                setAlertModal(false)
            }, 1000)
        } else {
            if (response.statusCode === 401) {
                adminLogout()
            } else {
                setAlertModalContent(response.message)
                setAlertModal(!alertModal)
            }
        }
    }

    const changeHandler = (value) => {
        let email = value?.trim()
        handleDebounceEmailCheck(email);
    }
    const handleDebounceEmailCheck = useCallback(debounce((email) => emailCheckFuncCall(email), 500), []);
    const emailCheckFuncCall = async (value) => {
        const token = localStorage.getItem('token')
        let response = '';
        response = await dispatch(checkIsValidEmail(value, token))
        if (response.success) {
            setIsValidEmail(true)
        } else {
            if (response?.data?.error?.message === 'Email Already Exists') {
                setIsValidEmail(false)
            } else if (response.statusCode === 401) {
                adminLogout()
            } else {
                setAlertModalContent(response.message || 'Something went wrong, please try again.')
                setAlertModal(!alertModal)
            }
        }
    }
    const adminLogout = () => {
        dispatch(storeAdminDetails([], {}))
        dispatch(logoutAdmin())
        localStorage.removeItem('adminRolesData')
        localStorage.removeItem('adminName')
        localStorage.removeItem('adminEmail')
        localStorage.removeItem('token')
        history.push('./sign-in')
        window.location.reload(false);
    }
    const zipChangeHandler = async (value) => {
        const token = localStorage.getItem('token')
        let response = '';
        if (value.length === 5) {
            response = await dispatch(checkIsZipCode(value, token))
            if (response.success) {
                setIsValidZip(true)
                pageProps.setFieldValue('billToState', response.data?.state)
                pageProps.setFieldValue('billToCity', response.data?.city)
            } else {
                if (response?.data?.error?.message === 'Invalid Zip Code.') {
                    setIsValidZip(false)
                    pageProps.setFieldValue('billToState', '')
                    pageProps.setFieldValue('billToCity', '')
                } else if (response.statusCode === 401) {
                    adminLogout()
                } else {
                    setAlertModalContent(response.message || 'Something went wrong, please try again.')
                    setAlertModal(!alertModal)
                }
            }
        } else {
            setIsValidZip(true)
            pageProps.setFieldValue('billToState', '')
            pageProps.setFieldValue('billToCity', '')
        }

    }

    return (
        <>
            <div>
                <div className='section-header'>
                    <img src={RightArrow} alt="RightArrow" className="right-arrow" />
                    <p>Bill-To Information<span className='star'>&#42;</span></p>
                </div>

                <div style={{ margin: '10px 0 0 80px' }}>

                    <InputFieldsWrapper>
                        <div className="row mb-4">
                            <CheckboxInput
                                name="billToCheckBox"
                                label='Same as Company Profile Information'
                                handleSelect={(e) => {
                                }}
                            />
                        </div>

                        {!pageProps.formikProps.values.billToCheckBox &&
                            <>
                                <div className="row">
                                    <div className="col-md-6">
                                        <TextInput name='billToBusinessName' placeholder={`Company Name*`} inputType='companyAndLocationText' />
                                    </div>
                                    <div className="col-md-6">
                                        <TextInput name='billToAddress' placeholder={`Address*`} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <TextInput name="billToCity" placeholder={`City*`} inputType='text' />
                                    </div>
                                    <div className="col-md-6">
                                        <TextInput name="billToState" placeholder={`State*`} disabled inputType='text' />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className={!isValidZip ? 'col-md-6 error-styling-input' : 'col-md-6'}>
                                        <NumberInput name="billToZip" placeholder={`Zip*`} maxLength={5} callBackFlag={true} callBackFun={zipChangeHandler} />
                                        {!isValidZip && <p style={{ marginTop: '-7px' }}>Zipcode is invalid.</p>}
                                    </div>
                                    <div className="col-md-6">
                                        <PhoneNumber name="billToPhoneNumber" placeholder={`Billing Contact Phone Number*`} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <TextInput name='billToUserName' placeholder={`Billing Contact Full Name*`} inputType='text' />
                                    </div>
                                    <div className={!isValidEmail ? 'col-md-6 error-styling-input' : 'col-md-6'}>
                                        <div style={{ display: 'grid', gridTemplateColumns: '15fr 1fr' }}>
                                            <div>
                                                <TextInput name="billToEmail" placeholder={`Billing Contact Email*`} changeHandler={changeHandler} />
                                                {!isValidEmail && <p style={{ marginTop: '-7px' }}>Email already exists.</p>}
                                            </div>
                                            <div>
                                                {iIcon('billToEmail', 'Email contact of person that should receive invoicing.')}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className={!isValidEmail ? 'col-md-6 error-styling-input' : 'col-md-6'}>
                                        <div style={{ display: 'grid', gridTemplateColumns: '15fr 1fr' }}>
                                            <div>
                                                <TextInput name="otherToEmail" placeholder={`Other Contact Email`} changeHandler={changeHandler} />
                                                {!isValidEmail && <p style={{ marginTop: '-7px' }}>Email already exists.</p>}
                                            </div>
                                            {/* <div>
                                                {iIcon('otherToEmail', 'Email contact of person that should receive invoicing.')}
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </InputFieldsWrapper>
                </div>
            </div>

            <div>
                <div className='section-header'>
                    <img src={RightArrow} alt="RightArrow" className="right-arrow" />
                    <p>Tax ID</p>
                </div>
                <div style={{ margin: '10px 0 0 80px' }}>
                    <InputFieldsWrapper>
                        <div className="row">
                            <div className="col-md-6">
                                <NumberInput name='taxId' placeholder={`Tax Id`} maxLength={9} />
                            </div>
                            <div className="col-md-6">
                                <TextInput name='businessURL' placeholder={`Business Website URL`} maxLength={200} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <TextInput name='businessDescription' placeholder={`Business Description`} maxLength={200} />
                            </div>
                        </div>
                    </InputFieldsWrapper>
                </div>
            </div>

            <div className='button-section'>
                <div style={{ marginLeft: '80px' }}>
                    <button className={saveDisableState ? 'save-button disabled' : 'save-button'} disabled={saveDisableState} onClick={() => adminRegisterUserFunc()}>Save</button>
                    <button className='skip-button' onClick={() => pageProps.skipButtonCall()}>Skip</button>
                </div>
                <div style={{ display: 'flex' }}>
                    <div className='round-wrapper left' onClick={() => pageProps.nextStepCallBack('backward', 'step2')}><p></p></div>
                    <div className={saveDisableState ? 'round-wrapper right disabled' : 'round-wrapper right'} onClick={() => !saveDisableState && adminRegisterUserFunc()}><p></p></div>
                </div>
            </div>

            <AlertModal
                isOpen={alertModal}
                toggle={() => setAlertModal(!alertModal)}
                title=''
                content={alertModalContent}
            />
        </>
    )

}

export default BillTo